import React from 'react';
import formatMoney from 'utils/formatters/Money';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import DescriptionListItem from 'components/v2/DescriptionListItem';

class PaymentSummaryV2 extends React.Component {
  render() {
    const { total, paid, balance, credit_memos, currency, t } = this.props;
    return (
      (<div data-testid="div-ce8ff110" className="grid grid-cols-2 gap-y-4">
        <div data-testid="div-e801a16c">
          <DescriptionListItem dataTestId="DescriptionListItem-1fd0f1ef" label={titleize(t('TOTAL'))}>
            {formatMoney(total, currency)}
          </DescriptionListItem>
        </div>
        <div data-testid="div-b3c85646">
          <DescriptionListItem dataTestId="DescriptionListItem-ff0c1a42" label={titleize(t('PAID'))}>
            {formatMoney(paid, currency)}
          </DescriptionListItem>
        </div>
        <div data-testid="div-416be5b6">
          <DescriptionListItem dataTestId="DescriptionListItem-ae123dff" label={titleize(t('CREDIT'))}>
            {formatMoney(
              (credit_memos && credit_memos.length && credit_memos[0]?.total) ||
                0,
              currency,
            )}
          </DescriptionListItem>
        </div>
        <div data-testid="div-d377008b">
          <DescriptionListItem dataTestId="DescriptionListItem-2f179c10" label={titleize(t('BALANCE'))}>
            {formatMoney(balance, currency)}
          </DescriptionListItem>
        </div>
      </div>)
    );
  }
}

export default withTranslation()(PaymentSummaryV2);
